import React from 'react';
import { gettext } from '@eb/i18n';
import { ChevronDownChunky as ChevronDownChunkySvg } from '@eb/eds-iconography';
import random from 'lodash/random';

import { Heart as HeartSVG } from '@eb/eds-iconography';
import { User as UserSVG } from '@eb/eds-iconography';
import { Friends as FriendsSVG } from '@eb/eds-iconography';

export const ORGANIZER_ARTICLE_TYPE = 'organizer_article';
export const EVENT_TYPE = 'any';

// Buckets
export const AUTO_BOAT_AND_AIR_EVENTS = 'auto_boat_and_air_events';
export const BASED_ON_USER_SAVED_EVENTS = 'based_on_user_saved_events';
export const BEST_OF_CITY_EVENTS = 'best_of_city_events';
export const BUSINESS_AND_PROFESSIONAL_EVENTS =
    'business_and_professional_events';
export const CHARITY_AND_CAUSES_EVENTS = 'charity_and_causes_events';
export const COMMUNITY_AND_CULTURE_EVENTS = 'community_and_culture_events';
export const DISCOUNTED_EVENTS = 'discounted_events';
export const EDITORIAL_ARTICLES = 'editorial_articles';
export const FAMILY_AND_EDUCATION_EVENTS = 'family_and_education_events';
export const FASHION_AND_BEAUTY_EVENTS = 'fashion_and_beauty_events';
export const FEATURED_ARTICLES = 'featured_articles';
export const FILM_MEDIA_AND_ENTERTAINMENT_EVENTS =
    'film_media_and_entertainment_events';
export const FOLLOWED_PROFILES = 'followed_profiles';
export const RECOMMENDED_EVENTS = 'recommended_events';
export const FOOD_AND_DRINK_EVENTS = 'food_and_drink_events';
export const FREE_EVENTS = 'free_events';
export const FROM_ATTENDED_EVENT = 'from_attended_event';
export const FROM_FOLLOWED_ORGANIZER = 'from_followed_organizer';
export const GOVERNMENT_AND_POLITICS_EVENTS = 'government_and_politics_events';
export const HEALTH_AND_WELLNESS_EVENTS = 'health_and_wellness_events';
export const HOBBIES_AND_SPECIAL_INTEREST_EVENTS =
    'hobbies_and_special_interest_events';
export const HOME_AND_LIFESTYLE_EVENTS = 'home_and_lifestyle_events';
export const LIKED_EVENTS = 'liked_events';
export const MUSIC_EVENTS = 'music_events';
export const NEARBY_CITIES = 'nearby_cities';
export const NEARBY_CITY_EVENTS = 'nearby_city_events';
export const NEW_UNDERPERFORMING_EVENTS = 'new_underperforming_events';
export const ONLINE_EVENTS = 'online_events';
export const ORGANIZERS_TO_FOLLOW = 'organizers_to_follow';
export const OTHER_CATEGORIES = 'other_categories';
export const OTHER_EVENTS = 'other_events';
export const PERFORMING_AND_VISUAL_ARTS_EVENTS =
    'performing_and_visual_arts_events';
export const PERSONALIZED_EVENTS = 'personalized_events';
export const PERSONALIZED_FOOD_AND_DRINK_EVENTS =
    'personalized_food_and_drink_events';
export const PERSONALIZED_MUSIC_EVENTS = 'personalized_music_events';
export const POPULAR_EVENTS = 'popular_events';
export const POPULAR_PROFILES = 'popular_profiles';
export const RELIGION_AND_SPIRITUALITY_EVENTS =
    'religion_and_spirituality_events';
export const SCHOOL_ACTIVITIES_EVENTS = 'school_activities_events';
export const SCIENCE_AND_TECHNOLOGY_EVENTS = 'science_and_technology_events';
export const SEASONAL_AND_HOLIDAY_EVENTS = 'seasonal_and_holiday_events';
export const SMALL_CITY_FALLBACK = 'small_city_fallback';
export const SPORTS_AND_FITNESS_EVENTS = 'sports_and_fitness_events';
export const THIS_WEEKEND = 'this_weekend';
export const TOP_PICKS_EVENTS = 'top_picks_events';
export const TRAVEL_AND_OUTDOOR_EVENTS = 'travel_and_outdoor_events';
export const TRENDING_TOPIC_EVENTS = 'trending_topic_events';
export const USER_SAVED_EVENTS = 'user_saved_events';

// Project X buckets
export const PRIMARY_BUCKET = 'primary_bucket';
export const SECONDARY_BUCKET = 'secondary_bucket';

export const BUCKETS_NAMES = [
    AUTO_BOAT_AND_AIR_EVENTS,
    BASED_ON_USER_SAVED_EVENTS,
    BEST_OF_CITY_EVENTS,
    BUSINESS_AND_PROFESSIONAL_EVENTS,
    CHARITY_AND_CAUSES_EVENTS,
    COMMUNITY_AND_CULTURE_EVENTS,
    DISCOUNTED_EVENTS,
    FAMILY_AND_EDUCATION_EVENTS,
    FASHION_AND_BEAUTY_EVENTS,
    FILM_MEDIA_AND_ENTERTAINMENT_EVENTS,
    FOLLOWED_PROFILES,
    FOOD_AND_DRINK_EVENTS,
    FREE_EVENTS,
    FROM_ATTENDED_EVENT,
    GOVERNMENT_AND_POLITICS_EVENTS,
    HEALTH_AND_WELLNESS_EVENTS,
    HOBBIES_AND_SPECIAL_INTEREST_EVENTS,
    HOME_AND_LIFESTYLE_EVENTS,
    LIKED_EVENTS,
    MUSIC_EVENTS,
    NEARBY_CITIES,
    NEARBY_CITY_EVENTS,
    NEW_UNDERPERFORMING_EVENTS,
    ONLINE_EVENTS,
    OTHER_EVENTS,
    PERFORMING_AND_VISUAL_ARTS_EVENTS,
    PERSONALIZED_FOOD_AND_DRINK_EVENTS,
    PERSONALIZED_MUSIC_EVENTS,
    POPULAR_EVENTS,
    RECOMMENDED_EVENTS,
    RELIGION_AND_SPIRITUALITY_EVENTS,
    SCHOOL_ACTIVITIES_EVENTS,
    SCIENCE_AND_TECHNOLOGY_EVENTS,
    SEASONAL_AND_HOLIDAY_EVENTS,
    SMALL_CITY_FALLBACK,
    SPORTS_AND_FITNESS_EVENTS,
    THIS_WEEKEND,
    TRAVEL_AND_OUTDOOR_EVENTS,
    TRENDING_TOPIC_EVENTS,
    USER_SAVED_EVENTS,
];

export const BOOKMARK_EVENT_FEED = 'bookmark_event_feed';
export const RUN_SEARCH_HEADER = 'run_search_header';
export const SEE_MORE_FEED = 'see_more_feed';
export const VIEW_EVENT_FEED = 'view_event_feed';

// Madlibs
export const UPDATE_CONTENT = 'updateContent';
export const UPDATE_SEARCH_CRITERIA = 'UPDATE_SEARCH_CRITERIA';

// Moods options

export const DATE_TAG_TODAY = 'today';
export const DATE_TAG_TOMORROW = 'tomorrow';
export const DATE_TAG_THIS_WEEKEND = 'this_weekend';
export const DATE_TAG_THIS_WEEK = 'this_week';
export const DATE_TAG_NEXT_WEEK = 'next_week';
export const DATE_TAG_THIS_MONTH = 'this_month';
export const DATE_TAG_NEXT_MONTH = 'next_month';
export const DATE_TAG_ANY_DATE = 'current_future';
export const DATE_TAG_CUSTOM_DATE = 'date';
export const DATE_TAG_PICK_A_DATE = 'custom_date';

export const DATES_TAGS = [
    {
        key: DATE_TAG_TODAY,
        name: gettext('Today'),
    },
    {
        key: DATE_TAG_THIS_WEEKEND,
        name: gettext('This weekend'),
    },
    {
        key: DATE_TAG_NEXT_WEEK,
        name: gettext('Next week'),
    },
    {
        key: DATE_TAG_THIS_MONTH,
        name: gettext('This month'),
    },
    {
        key: DATE_TAG_CUSTOM_DATE,
        name: gettext('Pick a date'),
        iconType: <ChevronDownChunkySvg />,
    },
];

export const CATEGORY_DROPDOWN_SELECT = 'category_select';
export const EVENT_AUTOCOMPLETE_AFFILIATE = 'ebdssbeac';

// Search
export const SEARCH_SECTION = 'search';
export const SEARCH_AUTOCOMPLETE_SUGGESTIONS_URL =
    '/api/v3/destination/search/autocomplete/';
export const UPDATE_SEARCH_SUGGESTIONS = 'UPDATE_SEARCH_SUGGESTIONS';
export const SEARCH_QUERY_MAX_LENGTH = 1000;

// Empty State
export const DEFAULT_EMPTY_STATE = 'defaultEmptyState';
export const IS_AUTHENTICATED = 'isAuthenticated';
export const SHOULD_SUGGEST_RELOADING_PAGE = 'shouldSuggestReloadingPage';

// Icons
export const CALENDAR_ICON = 'calendarIcon';
export const HEART_ICON = <HeartSVG />;
export const USER_ICON = <UserSVG />;
export const FRIENDS_ICON = <FriendsSVG />;

// Experiments
export const SMALL_HEADER_OPTIMIZE_EXPERIMENT = 'd2s-QSQWRfizyqZVhEgUKw';

// Images
export const ONLINE_BANNER_URL =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F99891082%2F174963144412%2F1%2Foriginal.20200430-164830?w=1016&auto=format%2Ccompress&q=75&sharp=10&s=be5cc9aa4646e8daeb55c374bc923a05';

export const RACIAL_EDUCATION_IMAGE_URL =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F106046188%2F224447613814%2F1%2Foriginal.20200713-230017?w=1016&auto=format%2Ccompress&q=75&sharp=10&s=d44a109462fa3829c6e0dc9406de2268';

export const BLM_IMAGE_URL =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F106046394%2F224447613814%2F1%2Foriginal.20200713-230327?w=1024&auto=format%2Ccompress&q=75&sharp=10&s=a3b5e9b898a34d93ea2914b6cb894172';

export const BLACK_HISTORY_MONTH_HEADER_US_CA =
    'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/BHM-hp.png';

export const IN_PERSON_EVENTS_AU_NZ =
    'https://cdn.evbstatic.com/s3-build/perm_001/4b4dd7/django/images/homefeed/header-AU-NZ.jpg';

export const BEST_UK_AND_IRELAND_EVENTS =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F116773365%2F252646217916%2F1%2Foriginal.20201104-172231?w=1024&auto=format%2Ccompress&q=75&sharp=10&s=fb26280a9407521a865dddf2a78fb9dc';

export const BEST_ONLINE_COLLECTIONS_US =
    'https://cdn.evbstatic.com/s3-build/perm_001/9cba8b/django/images/homefeed/best-online-collections-US.jpeg';

export const BEST_ONLINE_COLLECTIONS_US_HD =
    'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/onilne-events-banner-2X.jpg';

export const RECONVENE =
    'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/Eventbrite-RECONVENE.jpg';

export const LIVE_EVENTS_ARE_BACK_US =
    'https://img.evbuc.com/https%3A%2F%2Fcdn.evbuc.com%2Fimages%2F136684873%2F174963144412%2F1%2Foriginal.20210526-163523?w=1024&auto=format%2Ccompress&q=75&sharp=10&s=99dd82aaf21c8a90b4221fdeca0517c6';

// Fullbleed Header Images
export const Daybreaker = {
    mobile:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/NIYT_home_headers/7316_NIYT+home+header_mobile_659x494.jpg',
    tablet:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/NIYT_home_headers/7316_NIYT+home+header_tablet_1067x470.jpg',
    desktop:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/NIYT_home_headers/7316_NIYT+home+header_web_1919x543.jpg',
    twok:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/NIYT_home_headers/7316_NIYT+home+header_4K_1920x544.jpg',
};

export const Daybreaker_alt = {
    mobile:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/Daybreaker_mobile_659x494.jpg',
    tablet:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/Daybreaker_tablet_1067x470.jpg',
    desktop:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/Daybreaker_web_1919x543.jpg',
    twok:
        'https://eventbrite-s3.s3.amazonaws.com/marketing/homepage/Daybreaker_4K_1920x544.jpg',
};

export const fullbleedHeaderImageList = [Daybreaker, Daybreaker_alt];

// For now this is the easiest way i've found to get random images on the header without changing the existing code very much
const fullbleedImageSetSelector = (fullbleedHeaderImageList) => {
    const randomIndex = random(fullbleedHeaderImageList.length - 1);
    return fullbleedHeaderImageList[randomIndex];
};

export const fullbleedHeaderImageSet = fullbleedImageSetSelector(
    fullbleedHeaderImageList,
);
// TLDs
export const TLD_ARGENTINA = '.com.ar';
export const TLD_AUSTRALIA = '.com.au';
export const TLD_BELGIQUE = '.be';
export const TLD_BRASIL = '.com.br';
export const TLD_CANADA = '.ca';
export const TLD_CHILE = '.cl';
export const TLD_COLOMBIA = '.co';
export const TLD_DENMARK = '.dk';
export const TLD_DEUTSCHLAND = '.de';
export const TLD_ESPANA = '.es';
export const TLD_FINLAND = '.fi';
export const TLD_FRANCE = '.fr';
export const TLD_HONG_KONG = '.hk';
export const TLD_IRELAND = '.ie';
export const TLD_ITALIA = '.it';
export const TLD_MEXICO = '.com.mx';
export const TLD_NEDERLAND = '.nl';
export const TLD_NEW_ZEALAND = '.co.nz';
export const TLD_OSTERREICH = '.at';
export const TLD_PERU = '.com.pe';
export const TLD_PORTUGAL = '.pt';
export const TLD_SCHWEIZ = '.ch';
export const TLD_SINGAPORE = '.sg';
export const TLD_SVERIGE = '.se';
export const TLD_UNITED_KINGDOM = '.co.uk';
export const TLD_UNITED_STATES = '.com';
export const TLD_GLOBALLY = 'global';

export const ALL_TLDs = [
    TLD_ARGENTINA,
    TLD_AUSTRALIA,
    TLD_BELGIQUE,
    TLD_BRASIL,
    TLD_CANADA,
    TLD_CHILE,
    TLD_COLOMBIA,
    TLD_DENMARK,
    TLD_DEUTSCHLAND,
    TLD_ESPANA,
    TLD_FINLAND,
    TLD_FRANCE,
    TLD_HONG_KONG,
    TLD_IRELAND,
    TLD_ITALIA,
    TLD_MEXICO,
    TLD_NEDERLAND,
    TLD_NEW_ZEALAND,
    TLD_OSTERREICH,
    TLD_PERU,
    TLD_PORTUGAL,
    TLD_SCHWEIZ,
    TLD_SINGAPORE,
    TLD_SVERIGE,
    TLD_UNITED_KINGDOM,
    TLD_UNITED_STATES,
];

// languages
export const LANGUAGE_ARGENTINA = 'es_AR';
export const LANGUAGE_AUSTRALIA = 'en_AU';
export const LANGUAGE_BELGIQUE = 'nl_BE';
export const LANGUAGE_BELGIQUE_2 = 'fr_BE';
export const LANGUAGE_BRASIL = 'pt_BR';
export const LANGUAGE_CANADA = 'en_CA';
export const LANGUAGE_CANADA_2 = 'fr_CA';
export const LANGUAGE_CHILE = 'es_CL';
export const LANGUAGE_COLOMBIA = 'es_CO';
export const LANGUAGE_DENMARK = 'en_DK';
export const LANGUAGE_DEUTSCHLAND = 'de_DE';
export const LANGUAGE_ESPANA = 'es_ES';
export const LANGUAGE_FINLAND = 'en_FI';
export const LANGUAGE_FRANCE = 'fr_FR';
export const LANGUAGE_HONG_KONG = 'en_HK';
export const LANGUAGE_IRELAND = 'en_IE';
export const LANGUAGE_ITALIA = 'it_IT';
export const LANGUAGE_MEXICO = 'es_MX';
export const LANGUAGE_NEDERLAND = 'nl_NL';
export const LANGUAGE_NEW_ZEALAND = 'en_NZ';
export const LANGUAGE_OSTERREICH = 'de_AT';
export const LANGUAGE_PERU = 'es_PE';
export const LANGUAGE_PORTUGAL = 'pt_PT';
export const LANGUAGE_SCHWEIZ = 'de_CH';
export const LANGUAGE_SCHWEIZ_2 = 'fr_CH';
export const LANGUAGE_SINGAPORE = 'en_SG';
export const LANGUAGE_SVERIGE = 'sv';
export const LANGUAGE_UNITED_KINGDOM = 'en_GB';
export const LANGUAGE_UNITED_STATES = 'en_US';

// Collections
export const EVENTS_THAT_CELEBRATE_QUEER_CULTURE_DURING_PRIDE = 'cwwyfmk';
export const EVENTS_TO_ATTEND_WITHOUT_STEPPING_FOOT_OUTSIDE = 'cwwqhpk';
export const MUSIC_EVENTS_TO_KEEP_YOU_DANCING_AT_HOME = 'cwwrkfd';
export const WELLNESS_EVENTS_TO_KEEP_YOU_GROUNDED = 'cwwrcfp';
export const EVENTS_FOR_KIDS_WHILE_PARENTS_WORK_FROM_HOME = 'cwwrdbd';
export const ARTS_AND_CRAFTS_EVENTS_TO_BING_COLOR_INTO_YOUR_LIFE = 'cwwrkgg';
export const FOOD_AND_DRINKS_EVENTS_TO_FEAST_ON_WHILE_RESTAURANTS_AND_BARS_ARE_CLOSED =
    'cwwrpkg';
export const FITNESS_CLASSES_FOR_BREAKING_A_SWEAT_AT_HOME = 'cwwttyy';
export const EVENTS_FOR_BUSINESS_SKILLS_AND_NETWORKING_FROM_HOME = 'cwwtbpp';
export const CONNECT_THROUGH_ONLINE_EVENTS = 'cwwqztp';
export const EDUCATE_YOURSELF_ONLINE_RACIAL_EQUITY_WORKSHOPS = 'cwwzzcp';
export const ENTERTAIMENT_TONIGHT = 'cwxbtcw';
export const TAKE_CARE_OF_YOURSELF_AND_YOUR_COMMUNITY = 'cwxmbwp';
export const BLACK_HISTORY_AND_BEYOND = 'cwxqphr';
export const TRICKS_AND_TREATS_VIRTUAL_HALLOWEEN_EVENTS_FOR_ALL_AGES =
    'cwxtcxp';
export const SOCIALISING_SAFELY_PHYSICALLY_DISTANT_EVENTS_IN_THE_UK = 'cwxtmmy';
export const BEST_UK_AND_IRELAND_EVENTS_URL = 'cwxygxg';
export const ONLINE_THANKSGIVING_COOKING = 'cwxzcyw';
export const NATIVE_AMERICAN_HERITAGE = 'cwxztxr';
export const FESTIVE_EVENTS_UK_AND_IE = 'cwxzxyd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_BRISBANE = 'cwxwfwy';
export const BEST_EVENTS_TO_EXPERIENCE_IN_PERTH = 'cwxwftp';
export const BEST_EVENTS_TO_EXPERIENCE_IN_AUCKLAND = 'cwxcbck';
export const HOLIDAY_EVENTS_CHRISTMAS_HANUKKAH_KWANZAA = 'cwycdzg';
export const VIRTUAL_NEW_YEAR_EVENTS_2020 = 'cwychcy';
export const FEEL_THE_LOVE_UK_IE = 'cwykqtd';
export const VIRTUAL_VALENTINE_US_CA = 'cwykwry';
export const BLACK_HISTORY_MONTH_US_CA = 'cwyhygw';
export const WOMENS_DAY_US_UK_IE = 'cwyrywd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_MELBOURNE = 'cwyczbd';
export const BEST_EVENTS_TO_EXPERIENCE_IN_SYDNEY = 'cwybhwr';
export const EVENT_PLANNING_WEBINARS_US_CA_UK_IE_AU = 'cwywhzb';
export const UK_FESTIVALS_2021 = 'cyfghwd';
export const STOP_ASIAN_HATE_US = 'ccbddmmg';
export const PARK_UP_UK = 'cwxctzw';
export const ALL_YOUR_FAVES_UK_IE = 'cgtyfwr';
export const VIRTUAL_EARTH_DAY_US_CA_UK_IE_AU_NZ = 'ccbfwgyd';
export const LOS_ANGELES_EVENT_CALENDAR_US = 'cfxrryy';
export const SAN_FRANCISCO_EVENT_CALENDAR_US = 'cfxrztd';
export const LONDON_EVENT_CALENDAR_UK = 'cgrrypy';
export const NEW_YORK_CITY_EVENT_CALENDAR = 'cfxwcyg';
export const CHICAGO_CITY_EVENT_CALENDAR = 'cfyzxpy';
export const WASHINGTON_DC_CITY_EVENT_CALENDAR = 'cfxtptk';

// QA collections
export const QA_TEST_BEST_HALLOWEEN_PARTIES_IN_WASHINGTON = 'cgrkwmk';
export const QA_TEST_MADE_FOR_NYC_FOOD_LOVERS = 'cfcpq';
export const QA_TEST_MOCKED_COLLECTION_FOR_TESTING = 'abc';
export const QA_TEST_MOCKED_COLLECTION_FOR_TESTING2 = 'abcd';
